import React from 'react'

import { Container } from '../../components/Bootstrap'
import Hero from '../../components/Hero'
import Layout from '../../components/Layout'
import Navigation from '../../components/Navigation'
import Summary from '../../components/Summary'
import TagCloud from '../../components/TagCloud'

import { bold } from '../../styles'

const data = [
  { text: 'consumers', size: 1.1 },
  { text: 'working', size: 1.1 },
  { text: 'people', size: 1.3 },
  { text: 'opportunity', size: 1.1 },
  { text: 'reach', size: 1.1 },
  { text: 'CILT', size: 1.6 },
  { text: 'make', size: 1.1 },
  { text: 'disability', size: 2.1 },
  { text: 'organization', size: 1.1 },
  { text: 'funding', size: 2.4 },
  { text: 'services', size: 1.1 },
  { text: 'need', size: 1.8 },
  { text: 'new', size: 1.1 },
  { text: 'think', size: 1.6 },
  { text: 'also', size: 1.1 },
  { text: 'members', size: 1.8 },
  { text: 'independent', size: 1.1 },
  { text: 'living', size: 1.1 },
  { text: 'program', size: 1.1 },
]

const ConsumerNine = () => (
  <Layout>
    <Hero>
      <h1>Question 9</h1>
      <p className={bold}>In your opinion, what might be the main factors or opportunities that could influence the Centre for Independent Living in Toronto (CILT) in the next three years?</p>
    </Hero>
    <Container>
      <Navigation prev="/consumers/8" next="/consumers/10" />
      <TagCloud words={data} />
	  <Summary>This word cloud shows that that the words most often used by respondents in response to the question of “What might be the main factors or opportunities that could influence the Centre for Independent Living in Toronto (CILT) in the next three years?” are: “Funding” and “Disability”, followed by “need” and “members”.</Summary>
    </Container>
  </Layout>
)

export default ConsumerNine
